import styled from "styled-components";

const Stack = styled.div`
  ${(props) => (props.padding ? `padding: ${props.padding} !important` : "")};
  ${(props) => (props.minHeight ? ` min-height:  ${props.minHeight} ` : "")};
  display: flex;
  flex-direction: ${(props) => props.direction || "row"};
  justify-content: ${(props) => props.justifyContent || "start"};
  align-items: ${(props) => props.alignItems || "start"};
  gap: ${(props) => (props.gap ? props.gap + "px" : "8px")};
  height: ${(props) => (props.height ? props.height : "100%")};
  width: ${(props) => (props.width ? props.width : "100%")};
  padding-top: ${(props) => (props.paddingTop ? props.paddingTop : "0px")};
  padding-left: ${(props) => (props.paddingLeft ? props.paddingLeft : "0px")};
  padding-right: ${(props) =>
    props.paddingRight ? props.paddingRight : "0px"};
  padding-bottom: ${(props) =>
    props.paddingBottom ? props.paddingBottom : "0px"};
  margin-top: ${(props) => (props.marginTop ? props.marginTop : "0px")};
  margin-bottom: ${(props) =>
    props.marginBottom ? props.marginBottom : "0px"};
`;

export default Stack;
